import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, Settings, MessageCircle } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    telefono: '',
    tamano: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormData({
        nombre: '',
        empresa: '',
        telefono: '',
        tamano: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1000);
  };
  return <section id="contacto" className="py-16 sm:py-24 bg-gray-50" data-id="element-11">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="text-center mb-10 sm:mb-12" data-id="element-13">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-14">
            Comienza hoy
          </h2>
          <p className="text-lg text-gray-600" data-id="element-15">
            Déjanos tus datos para agendar una demo o iniciar un piloto en tu
            obra.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-10" data-id="element-16">
          {isSuccess ? <div className="text-center py-12" data-id="element-17">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6" data-id="element-18">
                <CheckCircle2 className="h-8 w-8 text-green-600" data-id="element-19" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-20">
                ¡Gracias por tu interés!
              </h3>
              <p className="text-gray-600" data-id="element-21">
                Hemos recibido tus datos. Nos pondremos en contacto contigo a la
                brevedad.
              </p>
              <button onClick={() => setIsSuccess(false)} className="mt-8 text-blue-600 font-medium hover:text-blue-800" data-id="element-22">
                Enviar otro mensaje
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-23">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-24">
                <div data-id="element-25">
                  <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-26">
                    Nombre completo *
                  </label>
                  <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3" placeholder="Juan Pérez" data-id="element-27" />
                </div>
                <div data-id="element-28">
                  <label htmlFor="empresa" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-29">
                    Empresa *
                  </label>
                  <input type="text" id="empresa" name="empresa" required value={formData.empresa} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3" placeholder="Constructora XYZ" data-id="element-30" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-31">
                <div data-id="element-32">
                  <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-33">
                    Teléfono *
                  </label>
                  <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3" placeholder="+56 9 1234 5678" data-id="element-34" />
                </div>
                <div data-id="element-35">
                  <label htmlFor="tamano" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-36">
                    Tamaño aprox. de obra (m²)
                  </label>
                  <input type="text" id="tamano" name="tamano" value={formData.tamano} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3" placeholder="Ej: 5000 m2" data-id="element-37" />
                </div>
              </div>

              <div className="pt-4" data-id="element-38">
                <button type="submit" disabled={isSubmitting} className={`w-full flex justify-center py-3.5 px-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`} data-id="element-39">
                  {isSubmitting ? 'Enviando...' : 'Quiero probar Obra Digital'}
                </button>
                <p className="text-center mt-4 text-sm font-semibold text-blue-600" data-id="element-40">
                  Implementación en menos de 48 horas.
                </p>
              </div>
            </form>}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 sm:gap-6 mt-8 sm:mt-12" data-id="element-41">
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-42">
            <Zap className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" data-id="element-43" />
            <span data-id="element-44">No requiere capacitación</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-45">
            <Settings className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" data-id="element-46" />
            <span data-id="element-47">No requiere cambiar herramientas</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-48">
            <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" data-id="element-49" />
            <span data-id="element-50">Funciona con el WhatsApp que ya usas</span>
          </div>
        </motion.div>
      </div>
    </section>;
}